import { h } from 'preact';
import { intcomma } from 'journalize';

function Candidate({
  candidate,
  color,
  ignoreColor,
  totalVotes,
  raceIsCalled,
  raceIsUncontested,
  isViewable,
}) {
  let rowClass = 'candidate contest__candidate-row';

  if (raceIsCalled && candidate.is_winner) {
    rowClass += ' contest__candidate-row--winner';
  }

  if (!isViewable && !candidate.is_winner) {
    rowClass += ' contest__candidate-row--hidden';
  }

  const partyInitial = candidate.party.slice(0, 1).toUpperCase();

  return (
    <tr class={rowClass}>
      <td class="candidate__cell candidate__party">
        <span
          class={`pill-circle pill--${candidate.party.slice(0, 3)}`}
          style={totalVotes > 0 && !ignoreColor && { backgroundColor: color }}
        >
          {partyInitial}
        </span>
      </td>
      <th class="candidate__cell candidate__name">
        {raceIsCalled && candidate.is_winner && '\u2713 '}
        {candidate.ballot_name}{' '}
        {candidate.is_incumbent && (
          <span class="pill pill--basic">Incumbent</span>
        )}
      </th>
      <td class="candidate__cell candidate__votes">
        {raceIsUncontested ? '-' : intcomma(candidate.votes)}
      </td>
      <td class="candidate__cell candidate__pct">
        {raceIsUncontested || totalVotes <= 0
          ? '-'
          : (candidate.votes / totalVotes * 100).toFixed(1)}
        <span
          class={`candidate__pct-symbol ${(raceIsUncontested ||
            totalVotes <= 0) &&
            'always-hidden'}`}
        >
          %
        </span>
      </td>
    </tr>
  );
}

export default Candidate;



// WEBPACK FOOTER //
// ./componentsV2/Candidate.js